
import { Component, OnInit, ViewChild, EventEmitter, Output, ElementRef } from '@angular/core';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ErrorsEnum, ServiceStatus } from 'src/app/shared/models/enums.model';
declare var require: any
import { RebateRequestComponent } from '../../../../front-user/services/long-haul/rebate-request/rebate-request.component';
import { LongHaulRequestOption, LongHaulRequestFormulateDecision, LongHaulRequestOptionFormulatedDecision } from 'src/app/shared/models/long-haul.model';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-rebate-request-base-request-details',
  templateUrl: './rebate-request-base-request-details.component.html'
})

export class RebateRequestBaseRequestDetailsComponent implements OnInit {

  @ViewChild('pdfTable',{static: false}) pdfTable: ElementRef;
  @ViewChild('rebateRequest',{static: false}) rebateRequest: RebateRequestComponent;
  private rebateRequestId: string = "";
  public longHaulRequestOptions: LongHaulRequestOption[] = [];
  private longHaulRequestRequestorDecisionRequest: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  private longHaulRequestRequestorDecisionResponse: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  private selectedLongHaulRequestRequestorDecisionOption: LongHaulRequestOptionFormulatedDecision;
  private getRequestRequestorDecisionResponseObject: ResponseObject = new ResponseObject();
  private isRequestExpired: boolean = false;
  public showGrid: boolean = false;
  private isRequestClosed: boolean = false;
  constructor( private cookieService: CookieService, private longHaulService: LongHaulService, private globalServices: GlobalServices) {}
  ngOnInit() {

    const el = document.getElementsByClassName('sectionTitle');


  }
  onRebateRequestLoadedFlag(flag: boolean) {
    if (flag) {
      /*history.state.data = {
        requestId: this.rebateRequest.rebateRequestLoaded.Id,

      };*/
     /* localStorage.setItem('RequestId', this.rebateRequest.rebateRequestLoaded.Id);
      this.cookieService.set('RelatedRequestId',this.rebateRequest.rebateRequestLoaded.Id);*/
      this.rebateRequestId = this.rebateRequest.rebateRequestLoaded.Id;
      this.globalServices.isLoaderEnabled = true;
      this.longHaulRequestOptions = this.rebateRequest.rebateRequestLoaded.LongHaulRequestOptions;
      this.rebateRequest.showOptionDev = false;
      this.rebateRequest.editModeAdmin = true;
      this.isRequestExpired = this.rebateRequest.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Expired ? true : false;
      this.isRequestClosed = this.rebateRequest.rebateRequestLoaded.BaseRequest.IsCompleted ? true : false;
      this.loadComponents();
    }
  }
  loadComponents(): void {
    this.getRebateRequestOptions();
  }
  getRebateRequestOptions(): void {
    this.longHaulRequestRequestorDecisionRequest.LongHaulRequestId = this.rebateRequestId;
    for (let i: number = 0; i < this.longHaulRequestOptions.length; i++) {
      this.longHaulRequestRequestorDecisionRequest.LongHaulRequestOptionsFormulatedDecision[i] = new LongHaulRequestOptionFormulatedDecision();
      this.longHaulRequestRequestorDecisionRequest.LongHaulRequestOptionsFormulatedDecision[i].Id = this.longHaulRequestOptions[i].Id;
    }
    this.getRebateRequestRequestorDecision();
  }
  getRebateRequestRequestorDecision(): void {
    this.longHaulRequestRequestorDecisionRequest.IsFormulatedDecisionComponent = false;
    this.longHaulService.getRebateRequestToFormulateDecision(this.longHaulRequestRequestorDecisionRequest).subscribe(
      data => this.getRequestRequestorDecisionResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getRebateRequestRequestorDecisionCompleted()
    );
  }
  getRebateRequestRequestorDecisionCompleted(): void {
    if (this.getRequestRequestorDecisionResponseObject.Success) {
      this.longHaulRequestRequestorDecisionResponse = this.getRequestRequestorDecisionResponseObject.Data as LongHaulRequestFormulateDecision;
      if(this.longHaulRequestRequestorDecisionResponse.FormulatedDecision != null ){
        this.showGrid = true;
      }
      else
      {
        this.showGrid = false;
      }

      this.convertRebateNumbersToLetters();

    } else {
      //Enable Error

      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  convertRebateNumbersToLetters(): void {
    const numWords = require('num-words');
    let rebatePercentageLettersArr: string[] = [];
    for (let i: number = 0; i < this.longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision.length; i++) {
      if (+this.longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentage == 0) {
        this.longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentageLetters = "Zero";
      } else if (this.longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentage == "-" || this.longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentage == "--") {
        this.longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentageLetters = "No Rebate granted";

      }
      else if (this.longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentage == "13.5" ) {
        this.longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentageLetters = "Thirteen and a half";

      } else {
        rebatePercentageLettersArr = numWords(this.longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentage).split(' ');
        this.longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentageLetters = "";
        for (let j: number = 0; j < rebatePercentageLettersArr.length; j++) {
          rebatePercentageLettersArr[j] = rebatePercentageLettersArr[j].charAt(0).toUpperCase() + rebatePercentageLettersArr[j].slice(1);
          this.longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentageLetters += rebatePercentageLettersArr[j];
          if (j != rebatePercentageLettersArr.length - 1)
            this.longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentageLetters += " ";
        }
      }
    }
  }
}
